<template>
  <div v-loading="loading" :element-loading-text="'努力加載中'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <strong>{{title}}</strong>
      </div>
      <el-form ref="form" class="w-100-pct" :model="form" label-width="120" :label-position="'left'">
        <el-form-item :label="'備註'" required>
          <el-input :disabled="isReadonly" type="textarea" v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item :label="'附件'">
          <my-upload-image :key="timer" :fileDir="'director'" :disabled="isReadonly" :imageUrlList.sync="form.upload_list" :oldImageUrlList.sync="form.file_list" listType="picture-card"></my-upload-image>
        </el-form-item>
      </el-form>
      <div class="mt15">
        <el-button type="primary" @click="submit('form')">提交</el-button>
        <el-button type="warning" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import MyUploadImage from "@/components/Uploadimage.vue";
export default {
  components: {
    MyUploadImage,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    order_id: {
      type: Number,
      default: 0,
    },
    showData: {
      required: true,
      type: Object,
      default: () => { }
    },
  },
  name: "Business",
  data () {
    return {
      timer: '',
      loading: false,
      account: [],
      form: {
        content: '',
        upload_list: [],
        file_list: []
      },
    }
  },
  methods: {
    submit () {
      let form = this.form;
      if (form.content == '') {
        this.$message({
          showClose: true,
          message: '請添加備註信息！',
          type: 'error',
          offset: 160
        });
        return false;
      }
      let data = {};
      data.order_id = form.order_id;
      data.file_list = form.file_list;
      data.upload_list = form.upload_list;
      data.content = form.content;
      data.staff_id = sessionStorage.getItem('staff_id');
      this.loading = true;
      this.post('/api/order/director_remark', {
        ...data
      }).then(res => {
        // console.log(response);
        this.loading = false;
        if (res.status == 'cash') {
          this.$notify({
            showClose: true,
            message: '買入和賣出貨幣不能同時為現金！',
            type: 'error',
            offset: 160
          });
          return false;
        }
        if (res.status == 'success') {
          this.$notify({
            showClose: true,
            message: '修改成功！',
            type: 'success',
            offset: 160,
          });
          this.$emit('submit', {});
          this.$emit('update:visible', false);
        } else {
          this.$notify({
            showClose: true,
            message: '修改失敗，請重試！',
            type: 'error',
            offset: 160
          });
        }
      }).catch(error => {
        console.log(error);
      });

    },
    cancel () {
      this.$emit('update:visible', false);
    },
    async init () {
      this.loading = true;
      //请求数据初始化 
      this.form.order_id = this.order_id;
      this.loading = false;
      this.timer = new Date().getTime();
    },

  },
  async created () {
    await this.init();
  },
  watch: {
  }

}
</script>

<style lang="scss" scoped>
</style>